import React, { useState } from "react";
import {
  FilterByStatus,
  floatDistributionData,
  floatRequestMetrics,
  getFloatRequestSummary,
} from "./data";
import PageStyle from "../../../Components/Layout/PageLayout";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import {
  useGetAllloatRequestsQuery,
  useGetEmployeeFloatDashboardQuery,
} from "../../../../api/employeeFloat";
import { useNavigate } from "react-router";
import Pagination from "../../../Components/Pagination/Pagination";
import { TableActions } from "../../../Components/Misc/Actions";
import Table from "../../../Components/Table/Table";
import Retirement from "./retirement";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useGetRetentionMetricsQuery } from "../../../../api/hrApi";

const MetricCard = ({ title, value, icon }) => {
  return (
    <div className="bg-[#FFFFFF] w-full h-[134px] p-5 space-y-4 shadow-md rounded-md">
      <div className="mr-4">{icon}</div>
      <div>
        <p className="text-[18px] font-[600] text-[#29382A]">{value}</p>
        <h3 className="text-[14px] font-[400] text-[#666060]">{title}</h3>
      </div>
    </div>
  );
};

const DistributionCard = ({ title, value, color }) => {
  return (
    <div className="w-full p-5 space-y-4 border-r-1">
      <div className="flex items-center space-x-3">
        <div
          className="w-[10px] h-[10px] rounded-md"
          style={{
            backgroundColor: `${color}`,
          }}
        />
        <div>
          <p>{title}</p>
        </div>
      </div>
      <div>
        <h4 className="text-[18px] font-[600] text-[#29382A]">{value}</h4>
      </div>
    </div>
  );
};
const FloatReqestIndex = () => {
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [retirementLenght, setRetirementLenght] = useState(0);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [activeTab, setActiveTab] = React.useState("FloatRequests");
  const { data, isLoading } = useGetAllloatRequestsQuery({
    pageSize: pageSize,
    pageNumber: currentPage,
    searchText,
    filter,
    startDate,
    endDate,
  });
  function createYearArray() {
    const currentYear = new Date().getFullYear();
    const lowestYear = 2002;
    const years = [];

    for (let year = currentYear; year >= lowestYear; year--) {
      years.push(year);
    }

    return years;
  }
  const navigate = useNavigate();
  const yearArray = createYearArray();
  const actionButton = (
    <>
      <CTAButtons
        onClick={() =>
          navigate(
            "/dashboard/employee/employee-float-request/add-employee-float-request"
          )
        }
      >
        New Request
      </CTAButtons>
    </>
  );
  const { data: metrics } = useGetEmployeeFloatDashboardQuery({
    year: currentYear,
  });
  const { data: retentionMetrics } = useGetRetentionMetricsQuery({
    year: currentYear,
  });
  console.log(retentionMetrics, "retentionMetrics");
  const floatRequestMetrics = getFloatRequestSummary(
    metrics?.responseObject?.costOfAcquisition,
    metrics?.responseObject?.costOfRetention,
    metrics?.responseObject?.totalFloatUtilized,
    metrics?.responseObject?.floatROI,
    metrics?.responseObject?.budgetUtilized
  );
  const handleEdit = (id) => {
    if (id) {
      navigate(`${id}/edit`);
    }
  };
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };
  const handleOpenDeleteModal = (id) => {
    if (id) {
      // setSelectedId(id);
      // setOpenDelete(true);
    }
  };
  const purposes = [
    { label: "Business Development", value: 0 },
    { label: "Relationship Management", value: 1 },
  ];
  const requestForOptions = [
    { label: "Self", value: 0 },
    { label: "Team", value: 1 },
  ];
  const floatList = [
    {
      label: "Float Advance",
      value: 0,
    },
    {
      label: "Promotional Items",
      value: 1,
    },
    { label: "Perishables", value: 2 },
    {
      label: "Visitation",
      value: 3,
    },
  ];
  const tableContent = isLoading ? (
    <tr>
      <td colSpan={6} className="text-center">
        Loading...
      </td>
    </tr>
  ) : data?.responseObject?.data?.length > 0 ? (
    data?.responseObject?.data?.map((item, index) => {

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item?.requestorName}</td>
          <td>{purposes.filter((purpose) => purpose.value === item?.purpose)[0]?.label}</td>
          <td>{requestForOptions.filter((requestFor) => requestFor.value === item?.requestFor)[0]?.label}</td>
          <td>{item?.color}</td>
          <td>{item?.effectiveDate}</td>
          <td>{item?.noOfDays}</td>
          <td>{item?.floatTypes?.map((floatType) => floatList.find((float) => float.value === floatType)?.label).filter(Boolean).join(", ")}</td>
          <td>{FormatDateTime(item?.submittedDate)}</td>
          <td>{item?.status}</td>
          <td>
            <TableActions hasChildren={true} url={`${item.id}/view`}>
              {[
                {
                  name: item?.approvalStatus !== 0 ? "Edit" : null,
                  action:
                    item?.approvalStatus !== 0
                      ? () => handleEdit(item.id)
                      : null,
                },
                {
                  name: "View",
                  action: () => handleView(item.id),
                },
                {
                  name: "Delete",
                  action: () => handleOpenDeleteModal(item.id),
                },
              ]}
            </TableActions>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No Status Label Found
      </td>
    </tr>
  );
  return (
    <PageStyle
      hasBack={false}
      demoTitle={"EMPLOYEE FLOAT REQUEST"}
      hasTopPageDemo
    >
      <div>
        <div className="flex justify-between items-center">
          <div className="w-full">
            <h2 className="text-[#4B664C] text-[23px] font-[500]">Float</h2>
          </div>
          <div className="flex items-center w-auto">
            <select
              className="border border-customGreen py-3 text-baseFont outline-none focus:ring-0 rounded-md w-[120px]"
              onChange={(e) => {
                setCurrentYear(e.target.value);
              }}
            >
              {yearArray.map((year, index) => (
                <option className="w-full" key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="lg:flex grid grid-cols-3 items-center space-y-3 space-x-3">
          {floatRequestMetrics.map((metric, index) => (
            <MetricCard
              key={index}
              title={metric.title}
              value={
                metric.isPercentage ? `%${metric.value}` : `₦${metric.value}`
              }
              icon={
                <img
                  src={metric.icon}
                  className="w-[30px] h-[30px]"
                  alt={metric.title}
                />
              }
            />
          ))}
        </div>
        <div className="mt-10">
          <div>
            <h4 className="text-[#4B664C] text-[20px] font-[500]">
              Float Type Distribution (YTD)
            </h4>
          </div>
          <div className="lg:flex grid grid-cols-3 items-center space-y-3 space-x-3">
            {floatDistributionData.map((data, index) => (
              <DistributionCard
                key={index}
                title={data.title}
                value={data.value}
                color={data.color}
              />
            ))}
          </div>
        </div>
        <div>
          <div className="mb-4">
            <div style={{ display: "flex", borderBottom: "1px solid #305F32" }}>
              <button
                type="button"
                onClick={() => setActiveTab("FloatRequests")}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  borderBottom:
                    activeTab === "FloatRequests"
                      ? "2px solid #305F32"
                      : "none",
                  background: "none",
                  cursor: "pointer",
                  fontWeight: activeTab === "FloatRequests" ? "bold" : "normal",
                }}
              >
                Float Requests{" "}
                <span
                  style={{
                    backgroundColor:
                      activeTab === "FloatRequests" ? "#305F32" : "#EFF6F0",
                    color: activeTab === "FloatRequests" ? "white" : "#6E9170",
                    borderRadius: "50%",
                    padding: "2px 8px",
                    marginLeft: "8px",
                    fontSize: "12px",
                  }}
                >
                  {data?.responseObject?.data?.length}
                </span>
              </button>
              <button
                type="button"
                onClick={() => setActiveTab("OutstandingRequests")}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  borderBottom:
                    activeTab === "OutstandingRequests"
                      ? "2px solid #305F32"
                      : "none",
                  background: "none",
                  cursor: "pointer",
                  fontWeight:
                    activeTab === "OutstandingRequests" ? "bold" : "normal",
                }}
              >
                Outstanding Requests{" "}
                <span
                  style={{
                    backgroundColor:
                      activeTab === "OutstandingRequests"
                        ? "#305F32"
                        : "#EFF6F0",
                    color:
                      activeTab === "OutstandingRequests" ? "white" : "#6E9170",
                    borderRadius: "50%",
                    padding: "2px 8px",
                    marginLeft: "8px",
                    fontSize: "12px",
                  }}
                >
                  {retirementLenght}
                </span>
              </button>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <form className={DashboardStyle.dashboard_filter}>
              <SearchFilter
                value={searchText}
                text={(searchText) => setSearchText(searchText)}
              />
              <CalendarFilter2
                name="Select Date Range"
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                normalDate
              />
              <ProDropFilter
                filter={filter}
                setFilter={setFilter}
                name={"Status"}
                filterBy={FilterByStatus}
              />
            </form>
            {activeTab === "FloatRequests" && <div>{actionButton}</div>}
          </div>
          {activeTab === "FloatRequests" && <div className={DashboardStyle.dashboard_table_holder}>
            <Table>
              <thead>
                <tr>
                  <th>S/N</th>
                  <th style={{ cursor: "pointer" }}>Request By</th>
                  <th style={{ cursor: "pointer" }}>Purpose</th>
                  <th style={{ cursor: "pointer" }}>Request For</th>
                  <th>Color</th>
                  <th style={{ cursor: "pointer" }}>Effective Date</th>
                  <th style={{ cursor: "pointer" }}>No of Days</th>
                  <th>Float Type</th>
                  <th>Date Requested</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{tableContent}</tbody>
            </Table>
            <Pagination
              last_page={data?.totalPages}
              present_page={data?.currentPage}
              totalRows={data?.totalRows}
              pageSize={pageSize}
              setPageSize={(page) => setPageSize(page)}
              click={(page) => setCurrentPage(page)}
            />
          </div>}
          {
            activeTab === "OutstandingRequests" && <Retirement startDate={startDate} endDate={endDate} pageSize={pageSize} currentPage={currentPage} searchText={searchText} filter={filter} setCurrentPage={setCurrentPage} setPageSize={setPageSize} retirementLenght={retirementLenght} setRetirementLenght={setRetirementLenght} />
          }

        </div>
      </div>
    </PageStyle>
  );
};

export default FloatReqestIndex;
